// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DatabaseOutlinedSvg from "@fishx/icons-svg/es/asn/DatabaseOutlined";
import FishxIcon from '../components/FishxIcon';

var DatabaseOutlined = function DatabaseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseOutlinedSvg
  }));
};

DatabaseOutlined.displayName = 'DatabaseOutlined';
export default React.forwardRef(DatabaseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DatabaseOutlined.js
// module id = 2382
// module chunks = 0